const ThemeActionTypes = {
  SET_THEME_SETTING: 'SET_THEME_SETTING',
};

export default ThemeActionTypes;
